// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const BannerVendi: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="valutazione space-pt">
            <h2 className="text-center mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.title') as string }} />
            <div className="bg-valuta">
                <div className="container-fluid text-center">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
                            <Link className="btn btn-primary" to="/valutazione">
                                <span>{t('homePage.sellBanner.btnText')}</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerVendi;